import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import fr from './locales/fr'

Vue.use(VueI18n)

const SUPPORTED_LOCALES = ['en', 'fr']

const resolveLocale = () => {
    // 1. User's explicit locale choice (persists across navigations)
    const saved = localStorage.getItem('locale')
    if (saved && SUPPORTED_LOCALES.includes(saved)) {
        return saved
    }

    // 2. Establishment locale injected by Blade (initial default)
    if (window.appLocale && SUPPORTED_LOCALES.includes(window.appLocale)) {
        return window.appLocale
    }

    // 3. Browser language fallback
    const browserLocale = navigator.language || navigator.userLanguage || 'fr'
    const shortLocale = browserLocale.split('-')[0]
    return SUPPORTED_LOCALES.includes(shortLocale) ? shortLocale : 'fr'
}

const locale = resolveLocale()

// Persist resolved locale for consistency across page loads
localStorage.setItem('locale', locale)

const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'fr',
    messages: {
        en,
        fr,
    },
})

// Expose a method to switch locale at runtime (e.g. when switching establishment)
export function setLocale(newLocale) {
    if (SUPPORTED_LOCALES.includes(newLocale)) {
        i18n.locale = newLocale
        localStorage.setItem('locale', newLocale)
    }
}

export default i18n
